<ti-spinner *ngIf="isLoading"></ti-spinner>
<div *ngIf="editMode" class="hint">{{ strings.possibleInsertions }}: ##UserName##, ##SourceRoomName##</div>
<ti-editor *ngIf="editMode" class="editor" [(value)]="template"></ti-editor>

<ng-container *ngIf="!editMode">
  <button class="edit-button about-room-viewer__button" *ngIf="canEdit" kendoButton fillMode="flat" (click)="enableEditMode()">
    <span class="fa fa-pencil"></span><span>{{ strings.edit }}</span>
  </button>

  <div class="content">
    <p #templateArea class="template" [innerHtml]="sanitizedTemplate"></p>
  </div>
</ng-container>
